<template>
  <div style="height:100%;width:100%;" id="app">
    <router-view ref="routerView" class="router-content"></router-view>
  </div>
</template>

<script>
import axios from 'axios'
import GLOBAL from '../../../components/jiri/Global'
import AppCall from '../../preview/appcall/utils/appcall.js'
import callapp from 'callapp'

window.HBHThat = ''

export default {
  beforeMount() {},
  mounted() {
    // 隐藏app关闭按钮
    callapp('uiCloseBtn', { hide: 'true' })
    sessionStorage.removeItem('registryAreaCode')
    this.cityId = GLOBAL.getCookie('city-id')
    this.getAllCity()
    this.showStrategy()
  },
  data() {
    return {
      cityId: 0,
    }
  },

  methods: {
    /**
     * 获取城市信息
     */
    getAllCity() {
      var that = this
      if (!sessionStorage.getItem('listAllCity')) {
        // 后台API请求参数
        let requestData = {}
        //获取城市列表信息
        axios
          .post(
            GLOBAL.getUrlDomainForRegistry() + 'list-all-city',
            requestData,
            {
              headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'city-id': that.cityId,
                Authorization: that.token
              }
            }
          )
          .then(function(result) {
            var code = result.data.code
            // 成功
            if (code === 0) {
              sessionStorage.setItem(
                'listAllCity',
                JSON.stringify(result.data.data)
              )
            } else if (code === -1) {
              that.setData({
                // 设置未登录信息
                cityMessage: result.data.message,
                // 显示未登录信息弹窗
                cityPopShow: true
              })
              // 1秒后自动关闭收藏信息提示弹窗
              setTimeout(that.closePop, 1000)
              // console.log(result.data.message)
            }
          })
      }
    },
    showStrategy() {
      // var that = this
      // areaCode中是否指定了城市跳转
      var url = 'strategy.html'
      if (
        this.cityId &&
        this.cityId != 0
      ) {
        url = 'strategy.html'
      } else {
        url = 'city.html'
      }
      location.assign(url)
    }
  }
}
</script>

<style>
.router-content {
  position: absolute;
  left: 0;
  top: 0;
}
</style>
